import {ReactNode} from "react";
import {AxiosError} from "axios";

export enum AppAlertTypesEnum {
    Basic = 'basic',
    Timeout = 'timeout',
    Mismatch = 'mismatch',
}

export enum AppSessionStorageKeysEnum {
    User = 'User'
}

export interface AppSessionStorageItemDto {
    type: AppSessionStorageKeysEnum.User;
    data: AppSessionStorageUserItemDto;
}

export interface AppSessionStorageUserItemDto {
    token: string;
    isAuthorized: boolean;
}

export interface ColumnStylesDto {
    width?: string | number;
    maxWidth?: string | number;
}

export interface ColumnDto {
    field: string;
    name: ReactNode;
    sortable?: boolean;
    resizable?: boolean;
    show?: boolean;
    inline?: boolean;
    colspan?: number;
    style?: ColumnStylesDto;
}

export interface SelectableDto<T = unknown> {
    selectionItems: T[];
    selectedItems: T[];
    onSelect: (selectionItem: T) => void;
    onSelectAll?: (selectionItems: T[]) => void;
    indicator?: ReactNode;
}

export enum SortOrderEnum {
    Asc = 'asc',
    Desc = 'desc',
}

export interface SortableDetailsDto {
    field: string;
    order: SortOrderEnum;
}

export interface SortableDto {
    sortDetails: SortableDetailsDto[];
    onSort: (data?: SortableDetailsDto) => void;
}

export interface PageableDto {
    pageSize: number;
    currentPage: number;
    totalElements: number;
    onPaginate: (pageNumber: number) => void;
}

export interface Pageable {
    offset?: number;
    sort?: Sort;
    pageNumber?: number;
    pageSize?: number;
    paged?: boolean;
    unpaged?: boolean;
}

export interface PageDto {
    totalPages?: number;
    totalElements?: number;
    size?: number;
    number?: number;
    sort?: Sort;
    first?: boolean;
    numberOfElements?: number;
    pageable?: Pageable;
    last?: boolean;
    empty?: boolean;
}

export interface Sort {
    unsorted?: boolean;
    sorted?: boolean;
    empty?: boolean;
}

export enum DispatchTypesEnum {
    Send = 'SEND_EMAIL_NOTIFICATION_REQUEST',
    Success = 'SEND_EMAIL_NOTIFICATION_SUCCESS',
    Failure = 'SEND_EMAIL_NOTIFICATION_FAILURE',
}


export interface DateFilter {
    filterCriterion: FilterCriterionEnum,
    dateTime: string,
}

export enum FilterCriterionEnum {
    Before = "createdBefore",
    After = "createdAfter"
}

export interface SortDto {
    field: string;
    order: SortOrderEnum;
}

export interface PageableInfoDto {
    page: number,
    size: number,
    //sort: SortDto[];
}

export interface ApiError {
    message: string;
    status: number;
    error: string;
    timestamp: string;
    exception: string;
    trace: string;
}

export interface ApiErrors {
    code?: number | string;
    message?: string;
    body?: string;
    apiError?: AxiosError<ApiError>;
    // Failures marked silent never trigger the global /error redirect.
    silent?: boolean;
}


export enum DateRangeTypesEnum {
    LAST_5_MINUTES = 'LAST_5_MINUTES',
    LAST_10_MINUTES = 'LAST_10_MINUTES',
    LAST_15_MINUTES = 'LAST_15_MINUTES',
    LAST_30_MINUTES = 'LAST_30_MINUTES',
    LAST_1_HOUR = 'LAST_1_HOUR',
    LAST_4_HOURS = 'LAST_4_HOURS',
    LAST_12_HOURS = 'LAST_12_HOURS',
    LAST_1_DAY = 'LAST_1_DAY',
    LAST_1_MONTH = 'LAST_1_MONTH',
    LAST_3_MONTHS = 'LAST_3_MONTHS',
    LAST_6_MONTHS = 'LAST_6_MONTHS',
    LAST_12_MONTHS = 'LAST_12_MONTHS',
    AROUND_TIME = 'AROUND_TIME',
    CUSTOM = 'CUSTOM',
}

export enum DatePeriodEnum {
    Minutes = 'MINUTES',
    Hours = 'HOURS',
    Days = 'DAYS',
    Weeks = 'WEEKS'
}

export enum StoreLoadingEnum {
    idle = 'idle',
    pending = 'pending',
    loaded = 'loaded',
}

export interface ApiSubError {
    object: string;
    field: string;
    rejectedValue: number;
    message: string;
    code: string;
}

export interface ApiError {
    code?: number | string;
    message: string;
    body?: string;
    subErrors?: ApiSubError[];
    apiError?: AxiosError<ApiError>;
}

export type RecipientType = "TO" | "CC" | "BCC";

export interface AppFileActionProps {
    uuid: string;
    id: number;
}

export interface AppFileUploadProps {
    file: File;
    //callback: (payload: FileEntityDto) => void;
}
